import './index.css';

import LoadingIcons from 'react-loading-icons';
import ClusterItem from '../ClusterItem';
import { SubscriptionSummary } from '../../../types/subscription';
import { Transaction } from 'grts-utils/src/types/Transaction';
import GlobalLoader from '../../../components/GlobalLoader';
import NoSubscriptionsNotice from '../../../components/NoSubscriptionsNotice';
import { useDimensions } from '../../../hooks/useDimensions';
import ClusterOverviewCharts from '../ClusterItem/Charts';
import { colors } from '../../../colors';
import LatestTransactions from '../LatestTransactions';
import Summary from '../Summary';
import { useSelector } from 'react-redux';
import {
  selectOverviewChartPercentage,
  setOverviewChartPercentage,
} from '../../../store/slices/ui';
import { useDispatch } from 'react-redux';
import useWidthBreakpoint from '../../../hooks/useWidthBreakpoint';

interface Props {
  totalValue?: number;
  subscriptions: SubscriptionSummary[];
  isLoading: boolean;
  transactions: Transaction[];
}

const Content = (props: Props) => {
  const { totalValue = 0, subscriptions, isLoading, transactions } = props;

  const dispatch = useDispatch();
  const { breakpoint } = useWidthBreakpoint();
  const overviewChartPercentage = useSelector(selectOverviewChartPercentage);
  const { dimensions, ref } = useDimensions();

  const handlePercentageClick = () =>
    dispatch(setOverviewChartPercentage(!overviewChartPercentage));

  if (!isLoading && !subscriptions?.length) {
    return <NoSubscriptionsNotice />;
  }

  if (isLoading && !subscriptions?.length) {
    return (
      <div className="overview-content-loading-container">
        <LoadingIcons.Grid width={100} />
      </div>
    );
  }

  return (
    <div
      className="overview-content-container"
      ref={ref}
      style={{
        overflowY: 'scroll',
        scrollSnapType: 'y mandatory',
      }}
    >
      <div
        style={{
          width: dimensions?.width,
          overflow: 'hidden',
          display: 'flex',
          scrollSnapAlign: 'center',
          borderBottom: '2px solid #242424',
          paddingBottom: breakpoint === 'sm' ? 0 : 12,
          minHeight: '45vh',
        }}
      >
        <Summary
          totalValue={totalValue}
          subscriptions={subscriptions}
          transactions={transactions}
        />
      </div>
      <div
        style={{
          width: dimensions?.width,
          height: dimensions?.height,
          overflow: 'hidden',
          display: 'flex',
          scrollSnapAlign: 'center',
          borderBottom: '2px solid #242424',
          paddingBottom: 12,
        }}
      >
        <ClusterItem
          totalValue={totalValue}
          subscriptions={subscriptions}
          transactions={transactions}
        />
      </div>
      <div
        style={{
          width: dimensions?.width,
          height: breakpoint === 'sm' ? 'auto' : dimensions?.height,
          overflow: 'hidden',
          scrollSnapAlign: 'center',
          borderBottom: '2px solid #242424',
          paddingBottom: 12,
        }}
      >
        <div
          style={{
            paddingTop: 10,
            paddingBottom: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <p
            style={{
              fontSize: 24,
              color: colors.white,
            }}
          >
            Charts
          </p>
          <p
            className={`chart-percentage${
              overviewChartPercentage ? '-selected' : ''
            }`}
            style={
              overviewChartPercentage
                ? { backgroundColor: colors.white, color: colors.black }
                : undefined
            }
            onClick={handlePercentageClick}
          >
            %
          </p>
        </div>

        <ClusterOverviewCharts
          totalValue={totalValue}
          subscriptions={subscriptions}
        />
      </div>

      <div
        style={{
          width: dimensions?.width,
          overflow: 'hidden',
          scrollSnapAlign: 'center',
        }}
      >
        <p
          style={{
            fontSize: 24,
            color: colors.white,
            paddingTop: 10,
            paddingBottom: 20,
            textAlign: 'center',
          }}
        >
          Latest Transactions
        </p>
        <LatestTransactions transactions={transactions} />
      </div>

      {isLoading && <GlobalLoader />}
      {/*<ClusterItem
        totalValue={totalValue}
        subscriptions={subscriptions}
        transactions={transactions}
      /> */}
    </div>
  );
};

export default Content;
